import React from "react";
import "./Projects.css";
import ProjectItem from "./ProjectItem";
import projectData from "./Project-data";

function Projects() {
  return (
    <section className="projects" id="projects">
      <div className="container">
        <h3>Projects </h3>
        <div className="projects-box">
          {projectData.map((project) => (
            <ProjectItem
              key={project.id}
              image={project.img}
              title={project.title}
              lang={project.programmingLanguage}
              description={project.description}
              links={project.links}
              features={project.features}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
